(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.boundSetHeaderHeight = this.setHeaderHeight.bind(this);
      this.mql = window.matchMedia('(max-width: 1024px)');
      this.mql.addEventListener('change', this.boundSetHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.scrollDirection = 'none';
      this.scrollDownAccum = 0;
      this.scrollUpAccum = 0;

      this.onScrollHandler = this.onScroll.bind(this);
      this.boundHide = this.hide.bind(this);
      this.boundReveal = this.reveal.bind(this);
      this.boundReset = this.reset.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.mql.removeEventListener('change', this.boundSetHeaderHeight);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const scrollThreshold = Math.min(this.headerBounds.bottom, 30);

      // ── Direction detection with deadzone ──
      // Track distance scrolled in each direction. Only reset accumulators
      // when a direction change commits (not on every opposite-tick), so
      // small bounces from iOS momentum don't wipe accumulated distance.
      const delta = scrollTop - this.currentScrollTop;
      if (delta > 0) {
        this.scrollDownAccum += delta;
      } else if (delta < 0) {
        this.scrollUpAccum -= delta;
      }

      const deadzone = 30;
      let directionChanged = false;

      if (this.scrollDownAccum >= deadzone && this.scrollDirection !== 'down') {
        this.scrollDirection = 'down';
        this.scrollDownAccum = 0;
        this.scrollUpAccum = 0;
        directionChanged = true;
      } else if (this.scrollUpAccum >= deadzone && this.scrollDirection !== 'up') {
        this.scrollDirection = 'up';
        this.scrollDownAccum = 0;
        this.scrollUpAccum = 0;
        directionChanged = true;
      }

      // Toggle padding classes only on committed direction change
      if (directionChanged && scrollTop > scrollThreshold) {
        this.header.classList.add('scrolled-past-header');
        if (this.scrollDirection === 'down') {
          this.header.classList.remove('header-scrolling-up');
        } else {
          this.header.classList.add('header-scrolling-up');
        }
      }

      // Sticky header hide/reveal
      if (scrollTop > this.currentScrollTop && scrollTop > scrollThreshold) {
        if (this.preventHide) { this.currentScrollTop = scrollTop; return; }
        requestAnimationFrame(this.boundHide);
      } else if (scrollTop < this.currentScrollTop && scrollTop > scrollThreshold) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.boundReveal);
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.boundHide);
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.header.classList.remove('header-scrolling-up');
        this.scrollDirection = 'none';
        this.scrollDownAccum = 0;
        this.scrollUpAccum = 0;
        requestAnimationFrame(this.boundReset);
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
